import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
        >
          <div className="container max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl shadow-2xl border border-black/10 p-6 md:p-8">
              <div className="flex flex-col md:flex-row md:items-center gap-6">
                {/* Icon and Text */}
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-xl bg-[var(--accent-wash)] flex items-center justify-center">
                      <Cookie className="w-5 h-5 text-[var(--accent-text)]" />
                    </div>
                    <h3 className="font-semibold text-[var(--text-primary)]">Cookie Preferences</h3>
                  </div>
                  <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
                    We use cookies to enhance your browsing experience, analyse site traffic, and personalise content. 
                    By clicking "Accept All", you consent to our use of cookies. Read our{' '}
                    <a href="/privacy" className="text-[var(--accent-text)] underline underline-offset-2">
                      Privacy Policy
                    </a>{' '}
                    for more information.
                  </p>
                </div>

                {/* Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 md:flex-shrink-0">
                  <button
                    onClick={handleDecline}
                    className="px-6 py-2.5 rounded-full border border-black/10 text-[var(--text-secondary)] font-medium hover:bg-black/5 transition-colors text-sm"
                  >
                    Decline
                  </button>
                  <button
                    onClick={handleAccept}
                    className="btn-primary text-sm px-6 py-2.5"
                  >
                    Accept All
                  </button>
                </div>

                {/* Close button */}
                <button
                  onClick={handleDecline}
                  className="absolute top-4 right-4 md:hidden p-2 rounded-full hover:bg-black/5 transition-colors"
                  aria-label="Close"
                >
                  <X className="w-4 h-4 text-[var(--text-muted)]" />
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
